import React from 'react';
import TrendBarChart from 'components/pure/charts/TrendBarChart';
import {scaleLinear, scaleTime} from 'd3-scale';
import moment from 'moment';

export default class RepProfileTrendChart extends React.Component {
  formatDate(value) {
    return moment(value).format('M/D');
  }

  render() {
    const {data, width, height, fill, yMax, margins} = this.props;
    if (data.size === 0) {
      return null;
    }
    const usedMargins = margins || {top: 10, right: 25, bottom: 20, left: 0};
    const svgDimensions = {width, height};

    // -2 is the space between each of the bars
    const barWidth = (width - usedMargins.right - usedMargins.left) / data.size - 2;
    const firstDate = data.get(0);
    const lastDate = data.get(-1);
    const xScale = scaleTime()
      .domain([firstDate.date.toDate(), lastDate.date.toDate()])
      .range([usedMargins.left, svgDimensions.width - usedMargins.right]);

    const usedYMax = yMax || Math.max(...data.map(d => d.value));

    const yScale = scaleLinear()
      .domain([0, usedYMax])
      .range([svgDimensions.height - usedMargins.bottom, usedMargins.top]);

    const timeFormatter = this.formatDate;
    const tickValues =
      data.size > 5
        ? [firstDate.date.toDate(), data.get(data.size / 2).date.toDate(), lastDate.date.toDate()]
        : data.map(d => d.date.toDate()).toArray();

    return (
      <TrendBarChart
        height={height}
        width={width}
        fill={fill}
        textXAdjust={1}
        data={data}
        barWidth={barWidth}
        margins={usedMargins}
        scales={{xScale, yScale}}
        timeFormatter={timeFormatter}
        tickValues={tickValues}
        tooltipContent={this.props.tooltipContent}
      />
    );
  }
}
